// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"5431c815","360":"d52cf475","453":"03346f77","562":"c53c30fa","594":"93d8c0bd","610":"09002d9d","875":"60837a61"}[chunkId] + ".chunk.js";
};